export enum MODAL_CONST {
  TEST_ID = 'modal',
  WRAPPER_TESTID = 'modal-wrapper',
}

export enum Alignment {
  TOP_LEFT = 'top-left',
  TOP_CENTER = 'top-center',
  TOP_RIGHT = 'top-right',
  CENTER_LEFT = 'center-left',
  CENTER_CENTER = 'center-center',
  CENTER_RIGHT = 'center-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_RIGHT = 'bottom-right',
}

export enum Context {
  IMMERSIVE = 'immersive',
  CONTEXTUAL = 'contextual',
}

export enum Radius {
  ROUNDED = 'rounded',
  SQUARE = 'square',
}

export enum Size {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
